module.exports = __webpack_public_path__ + "img/icon1.1473670e.svg";